/* eslint-disable global-require */
module.exports = ['payments.common.cartsummary.m17'];
